exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-header[data-v-f02e52e2]{background-color:var(--dark-color)}.nav-link.active[data-v-f02e52e2]{color:var(--dark-color)}.nav-link[data-v-f02e52e2]{color:var(--white-color);font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f02e52e2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/CrudCard.vue
// module id = 361
// module chunks = 0